import { Box, Skeleton, Stack, useTheme } from '@mui/material';

export default function LoadingSkelton() {
  const theme = useTheme();
  return (
    <Stack spacing={2}>
      {Array.from({ length: 5 }).map((_, index) => (
        <Box key={index} border={`1px solid ${theme.palette.divider}`} borderRadius={3} p={2.5} bgcolor='#fff'>
          <Stack spacing={2}>
            <Stack direction='row' justifyContent='space-between' alignItems='center' flexWrap='wrap' gap={1}>
              <Stack direction='row' alignItems='center' gap={1}>
                <Skeleton variant='rounded' width={72} height={24} sx={{ borderRadius: '10px' }} />
                <Skeleton variant='rounded' width={200} height={24} sx={{ borderRadius: '12px' }} />
              </Stack>
              <Skeleton variant='text' width={80} height={16} />
            </Stack>

            <Box borderBottom='1px solid #ECECEC' pb={1.5}>
              <Skeleton variant='text' width='70%' height={22} />
              <Skeleton variant='text' width='90%' height={18} sx={{ mt: 0.5 }} />
            </Box>

            <Stack direction='row' justifyContent='space-between' alignItems='center' flexWrap='wrap' gap={1}>
              <Stack direction='row' spacing={1}>
                <Skeleton variant='rounded' width={100} height={24} sx={{ borderRadius: '16px' }} />
                <Skeleton variant='rounded' width={80} height={24} sx={{ borderRadius: '16px' }} />
              </Stack>
              <Skeleton variant='text' width={90} height={16} />
            </Stack>
          </Stack>
        </Box>
      ))}
    </Stack>
  );
}
